<template>
	<div>
		<v-row>
			<v-col
				v-if="isAccountManager"
				class="d-flex align-center"
				cols="4"
			>
				<v-badge
					:value="thereAreFiltersApplied"
					color="primary"
					overlap
					right
					class="mr-4"
				>
					<v-btn
						color="secondary"
						@click="openFiltersDialog()"
						:disabled="isLoading"
					>
						Filtri
					</v-btn>
				</v-badge>
				
				<v-badge
					:value="computedAccountManagersIds?.length > 0"
					color="primary"
					overlap
					right
				>
					<v-btn
						color="secondary"
						@click="openAccountManagersTreeviewDialog()"
						:disabled="isLoading"
					>
						Seleziona Account Managers
					</v-btn>
				</v-badge>
			</v-col>
			
			<!--<v-col-->
			<!--	v-if="isAccountManager"-->
			<!--	cols="4"-->
			<!--	class="d-flex align-center"-->
			<!--&gt;-->
			<!--	<v-select-->
			<!--		v-model="computedAccountManagersIds"-->
			<!--		:items="accountManagers"-->
			<!--		label="Account managers"-->
			<!--		:loading="isLoadingAccountManagers"-->
			<!--		:disabled="isLoadingAccountManagers"-->
			<!--		item-value="id"-->
			<!--		item-text="nome_cognome"-->
			<!--		multiple-->
			<!--		clearable-->
			<!--		outlined-->
			<!--		dense-->
			<!--		hide-details-->
			<!--		class="mr-2"-->
			<!--	>-->
			<!--		<template v-slot:selection="{ item, index }">-->
			<!--			<v-chip small v-if="index < 2" >-->
			<!--				<span>{{ item.nome_cognome }}</span>-->
			<!--			</v-chip>-->
			<!--			<span-->
			<!--				v-if="index === 2"-->
			<!--				class="grey&#45;&#45;text text-caption ml-1"-->
			<!--			>-->
		  <!--        (+ {{ accountManagersIds.valueNonApplied.length - 2 }})-->
		  <!--      </span>-->
			<!--		</template>-->
			<!--	</v-select>-->
			<!--	<v-btn-->
			<!--		v-if="isAccountManager"-->
			<!--		color="secondary"-->
			<!--		@click="applyAccountManagersFilter()"-->
			<!--		:disabled="isLoading"-->
			<!--	>-->
			<!--		Applica-->
			<!--	</v-btn>-->
			<!--</v-col>-->
			
			<v-col cols="4">
				<v-text-field
					v-model="search"
					append-icon="mdi-magnify"
					label="Cerca"
					single-line
					hide-details
					outlined
					dense
				></v-text-field>
			</v-col>
			
			<v-col class="d-flex justify-end">
				
				<v-menu
					bottom
					:disabled="isLoading"
					v-if="user?.account_manager?.cambio_stato_fasi_in_massa_abilitato"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							color="secondary"
							v-bind="attrs"
							v-on="on"
						>
							Azioni in massa
						</v-btn>
					</template>
					
					<v-list>
						<v-list-item @click="apriDialogAzioneMassivaDataScadenzaSaldoEsitiProvvisori()">
							<v-list-item-title>Prima Scadenza Fattura Esiti Provvisori</v-list-item-title>
						</v-list-item>
						<v-list-item @click="apriDialogAzioneMassivaDataScadenzaSaldoEsitiDefinitivi()">
							<v-list-item-title>Prima Scadenza Fattura Esiti Definitivi</v-list-item-title>
						</v-list-item>
					</v-list>
				</v-menu>
				
			</v-col>
		</v-row>
		
		<v-row>
			<v-col>
				<contratti-di-servizio-data-table
					ref="contrattiDiServizioDataTable"
					:search="search"
					@is-loading="isLoadingContrattiDiServizioDataTable = $event"
				></contratti-di-servizio-data-table>
			</v-col>
		</v-row>
		
		<v-dialog
			v-model="accountManagersTreeviewDialog"
			:key="accountManagersTreeviewDialogKey"
			persistent
			max-width="700"
			scrollable
		>
			<account-managers-treeview
				@apply="applyAccountManagersFilter()"
				@close="accountManagersTreeviewDialog = false"
			></account-managers-treeview>
		</v-dialog>
		
		<v-dialog
			v-model="dialogAzioneMassivaDataScadenzaSaldoEsitiProvvisori"
			persistent
			max-width="600"
			scrollable
		>
			<cambio-data-scadenza-saldo-esiti-provvisori-in-massa
				:key="azioneMassivaDataScadenzaSaldoEsitiProvvisoriKey"
				:contratti-di-servizio-ids="contrattiDiServizioIds"
				@done="$refs.contrattiDiServizioDataTable.getContrattiDiServizio()"
				@close="dialogAzioneMassivaDataScadenzaSaldoEsitiProvvisori = false"
			></cambio-data-scadenza-saldo-esiti-provvisori-in-massa>
		</v-dialog>
		
		<v-dialog
			v-model="dialogAzioneMassivaDataScadenzaSaldoEsitiDefinitivi"
			persistent
			max-width="600"
			scrollable
		>
			<cambio-data-scadenza-saldo-esiti-definitivi-in-massa
				:key="azioneMassivaDataScadenzaSaldoEsitiDefinitiviKey"
				:contratti-di-servizio-ids="contrattiDiServizioIds"
				@done="$refs.contrattiDiServizioDataTable.getContrattiDiServizio()"
				@close="dialogAzioneMassivaDataScadenzaSaldoEsitiDefinitivi = false"
			></cambio-data-scadenza-saldo-esiti-definitivi-in-massa>
		</v-dialog>
		
	</div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";

export default {
	data() {
		return {
			isLoadingContrattiDiServizioDataTable: false,
			search: null,
			
			// accountManagers: [],
			isLoadingAccountManagers: false,
			
			accountManagersTreeviewDialog: false,
			accountManagersTreeviewDialogKey: 0,
			
			dialogAzioneMassivaDataScadenzaSaldoEsitiProvvisori: false,
			azioneMassivaDataScadenzaSaldoEsitiProvvisoriKey: 0,
			dialogAzioneMassivaDataScadenzaSaldoEsitiDefinitivi: false,
			azioneMassivaDataScadenzaSaldoEsitiDefinitiviKey: 0,
			contrattiDiServizioIds: []
		}
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			thereAreFiltersApplied: 'contrattiDiServizioFilters/thereAreFiltersApplied',
			accountManagersIds: 'sharedFilters/accountManagersIds',
			user: 'auth/user'
		}),
		computedAccountManagersIds: {
			get: function () {
				return this.accountManagersIds.value;
			},
			set: function (value) {
				if (value?.length === 0) value = null;
				this.setAccountManagersIdsNotApplied(value);
			}
		},
		isLoading() {
			return this.isLoadingContrattiDiServizioDataTable;
		}
	},
	
	// created() {
	// 	this.getAccountManagers();
	// },
	
	methods: {
		...mapMutations({
			setAccountManagersIdsNotApplied: 'sharedFilters/SET_ACCOUNT_MANAGERS_IDS_NOT_APPLIED',
			setAccountManagersIdsApplied: 'sharedFilters/SET_ACCOUNT_MANAGERS_IDS_APPLIED'
		}),
		...mapActions({
			salvaImpostazioniAmAction: 'shared/salvaImpostazioniAm',
		}),
		openFiltersDialog() {
			this.$refs.contrattiDiServizioDataTable.openContrattiDiServizioFilters();
		},
		// getAccountManagers() {
		// 	this.isLoadingAccountManagers = true;
		// 	axios.get('/api/account-managers')
		// 		.then(response => {
		// 			this.accountManagers = response.data;
		// 		})
		// 		.finally(() => {
		// 			this.isLoadingAccountManagers = false;
		// 		})
		// },
		openAccountManagersTreeviewDialog() {
			this.accountManagersTreeviewDialogKey++;
			this.accountManagersTreeviewDialog = true;
		},
		applyAccountManagersFilter() {
			// accountManagersIds lo passo via prop
			this.setAccountManagersIdsApplied(this.accountManagersIds.valueNonApplied);
			this.salvaImpostazioniAmAction();
			this.$refs.contrattiDiServizioDataTable.reloadContrattiDiServizio();
			this.accountManagersTreeviewDialog = false;
		},
		apriDialogAzioneMassivaDataScadenzaSaldoEsitiProvvisori() {
			this.azioneMassivaDataScadenzaSaldoEsitiProvvisoriKey++;
			this.contrattiDiServizioIds = this.$refs.contrattiDiServizioDataTable.contrattiDiServizio.map(p => p['id'])
			this.dialogAzioneMassivaDataScadenzaSaldoEsitiProvvisori = true;
		},
		apriDialogAzioneMassivaDataScadenzaSaldoEsitiDefinitivi() {
			this.azioneMassivaDataScadenzaSaldoEsitiDefinitiviKey++;
			this.contrattiDiServizioIds = this.$refs.contrattiDiServizioDataTable.contrattiDiServizio.map(p => p['id'])
			this.dialogAzioneMassivaDataScadenzaSaldoEsitiDefinitivi = true;
		},
	}
}
</script>

<style scoped>

</style>